import { Popover, styled } from "@mui/material";
import { Text } from "../Typography";
import { VerificationIndicator } from "../../types/LandToken";
import { useState } from "react";
import { PopupRow, PopupRowCell } from "../TransactionDetails/DetailsPopup";

type AssessmentPopupProps = {
  indicator: VerificationIndicator;
};
const AssessmentPopup = ({ indicator }: AssessmentPopupProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  // const handleClick = (event: MouseEvent<HTMLElement>) => {
  //   setAnchorEl(anchorEl ? null : event.currentTarget);
  // };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popup" : undefined;

  // const headers = [
  //   "Description",
  //   "Category",
  //   "Evaluation factors",
  //   "Evaluation methods",
  //   "Score values",
    
  // ]

  return (
    <div>
      <Text sx={{ gap: "6px", alignItems: "center", minWidth:'450px' }}>
        {/* <IconButton aria-describedby={id} onClick={handleClick}>
          <InfoRounded fontSize="small" color="disabled" />
        </IconButton> */}
        Evaluate the {indicator.description}
      </Text>
      <Popover
        slotProps={{
          paper: {
            sx: {
              border: "1px solid #dee2e6",
              boxShadow: "rgba(0, 0, 0, 0.15) 0px 8px 16px 0px",
              borderRadius: "8px",
              backgroundColor: "background.default",
            },
          },
        }}
        classes={{ paper: "PopoverPaper" }}
        onClose={() => setAnchorEl(null)}
        id={id}
        open={open}
        disableScrollLock={true}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: 30,
        }}
      >
        <Content>
          <Text bold medium sx={{ mb: 6 }}>
            Additional Info
          </Text>
          <PopupRow sx={{ flexDirection: "column-reverse" }}>
            <PopupRowCell sx={{ flexDirection: "column", alignItems: "start" }}>{indicator.description}</PopupRowCell>
            <PopupRowCell>Name</PopupRowCell>
          </PopupRow>
          <PopupRow sx={{ flexDirection: "column-reverse" }}>
            <PopupRowCell sx={{ flexDirection: "column", alignItems: "start" }}>{indicator.advance}</PopupRowCell>
            <PopupRowCell>Category</PopupRowCell>
          </PopupRow>
          <PopupRow sx={{ flexDirection: "column-reverse" }}>
            <PopupRowCell sx={{ flexDirection: "column", alignItems: "start" }}>
              {indicator.evaluation.map((item, index) => (
                <div style={{ textTransform: "capitalize" }} key={index}>
                  {item}
                </div>
              ))}
            </PopupRowCell>
            <PopupRowCell>Evaluation factors</PopupRowCell>
          </PopupRow>
          <PopupRow sx={{ flexDirection: "column-reverse" }}>
            <PopupRowCell sx={{ flexDirection: "column", alignItems: "start" }}>
              {indicator.method.map((item, index) => (
                <div style={{ textTransform: "capitalize" }} key={index}>
                  {item}
                </div>
              ))}
            </PopupRowCell>
            <PopupRowCell>Evaluation methods</PopupRowCell>
          </PopupRow>
          <PopupRow sx={{ flexDirection: "column-reverse" }}>
            <PopupRowCell sx={{ flexDirection: "column", alignItems: "start" }}>
              {indicator.parameters.map((item, index) => (
                <div style={{ textTransform: "capitalize" }} key={index}>
                  {item.value} = {item.description}
                </div>
              ))}
            </PopupRowCell>
            <PopupRowCell>Score values</PopupRowCell>
          </PopupRow>
        </Content>
      </Popover>
    </div>
  );
};

const Content = styled("div")`
  display: flex;
  flex-direction: column;
  padding: 12px;
`;

export default AssessmentPopup;
